<template></template>

<script>
export default {
  components: {},
  props: {
    events: {
      type: [String, Array],
      default: '',
    },
    uniqId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    this.listenEvents()
  },
  beforeUnmount() {
    this.unsubscribeListeners()
  },
  methods: {
    unsubscribeListeners() {
      this.eventsIds.forEach(this.$Events.removeHandler)
    },
    listenEvents() {
      if (Array.isArray(this.events)) this.events.forEach(this.listenEvent)
      else this.listenEvent(this.events)
    },
    listenEvent(eventName) {
      const id = this.$Events.handleEvent(
        eventName,
        (...args) => {
          this.onEvent(eventName, ...args)
        },
        this.uniqId,
      )
      this.eventsIds.push(id)
    },
    onEvent(eventName, ...args) {
      this.$emit(eventName, ...args)
    },
  },
}
</script>
